import { Dayjs } from 'dayjs';

import {
  ApplicationSource,
  ApplicationStatus,
} from '../../../common/constants';
import { Company, Job } from '../../../common/interfaces/entities';
import { GlintsChatChannelExchangeRequest } from './exchange-request';
import { GlintsChatChannelMember } from './member';
import { GlintsChatMessage } from './message';
import { GlintsChatTalent } from './talent';

export type GlintsChatChannelJob = Pick<Job, 'id' | 'title' | 'status'> & {
  countryCode: string;
  creatorID: string;
  fraudReportFlag: string | null;
};

export type GlintsChatChannelCompany = Pick<Company, 'id' | 'name' | 'status'>;

export const ChatStatus = {
  BLOCKED_CDD: 'BLOCKED_CDD',
  BLOCKED_COMP: 'BLOCKED_COMP',
  BLOCKED_MUTUAL: 'BLOCKED_MUTUAL',
} as const;

export type GlintsChatChannel = {
  id: string;
  type: string;
  chatStatus: string;
  applicationStatus: ApplicationStatus;
  firstCandidateRepliedAt?: string;
  creatorID: string;
  source: ApplicationSource;
  job: GlintsChatChannelJob;
  company: GlintsChatChannelCompany;
  members: GlintsChatChannelMember[];
  talent: GlintsChatTalent;
  unreadNumber: number;
  createdAt: Dayjs;
  updatedAt: Dayjs;
  exchangeRequests?: GlintsChatChannelExchangeRequest;
  messageList: GlintsChatMessage[];
};
